export default __webpack_public_path__ + "static/cctaAescola-f0d57c60f89a474bbcb9d69d92ce5edd.png";